import { connect } from 'react-redux';
import { getMaxPrice } from '../redux/shared/selectors';
import { dollarsToPoints } from '../utils/points';
const mapStateToProps = (state, ownProps)=>({
        maxValue: ownProps.maxValue || dollarsToPoints(getMaxPrice(state))
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
